export const encodeJSONToBase64 = (value: unknown): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  try {
    const json = JSON.stringify(value);
    if (!json) {
      return undefined;
    }

    if (typeof TextEncoder !== 'undefined') {
      const bytes = new TextEncoder().encode(json);
      let binary = '';
      bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
      });
      return btoa(binary);
    }

    return btoa(unescape(encodeURIComponent(json)));
  } catch (error) {
    console.error('Failed to encode JSON to base64', error);
    return undefined;
  }
};


